<template>
  <div>
    <div class="heaer-text">推广报表</div>
    <div style="overflow: hidden">
      <header-filter
        @downloadFile="downloadFile"
        @setExtensionHeaderColumn="setExtensionHeaderColumn"
        @showUploadFile="showUploadFile"
        @showLoding="showLoding"
      ></header-filter>
    </div>
    <extension-table
      :extensionList="extensionList"
      :column="column"
      :loading="loading"
      ref="usertable"
      @computTotalColumn="computTotalColumn"
      :totalColumn="totalColumn"
    ></extension-table>
    <extension-upload
      :uploadVisible="uploadVisible"
      @closeUploadFile="closeUploadFile"
    ></extension-upload>
  </div>
</template>

<script>
import HeaderFilter from "./headerFilter";
import ExtensionTable from "./extensionTable";
import { extensionHeader_column } from "../../config/table_comlun";
import ExtensionUpload from "./extensionUpload";
export default {
  name: "extension",
  data() {
    return {
      column: [],
      uploadVisible: false,
      loading: true,
      totalColumn: [],
    };
  },
  computed: {
    extensionList: function () {
      return this.$store.state.ExtenSion.extensionList;
    },
  },
  components: {
    HeaderFilter,
    ExtensionTable,
    ExtensionUpload,
  },
  // mounted() {
  //   let param = {
  //     order: "asc",
  //     offset: 0
  //   };
  //   this.$store.dispatch("getProductTableList", {
  //     param,
  //     cb: () => {}
  //   });
  // },
  methods: {
    showUploadFile() {
      this.uploadVisible = true;
    },
    closeUploadFile() {
      this.uploadVisible = false;
    },
    setExtensionHeaderColumn (param) {
      this.column = extensionHeader_column(param.col, param.header, param.def, param.sign);
      this.loading = false;
      this.$refs.usertable.refresh();
    },
    showLoding() {
      this.loading = true;
    },
    downloadFile() {
      this.$refs.usertable.downLoadFileToExcel();
    },
    computTotalColumn(arr) {
      this.totalColumn = arr;
    },
  },
};
</script>
<style scoped>
.heaer-text {
  padding: 16px 16px 6px 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
</style>